<template>
  <div  class="home-container">
    <!-- 菜单 -->
    <el-container>
      <el-header>
       <Navigation ref="nav"/>
      </el-header>
      <el-main>
        <router-view v-if="isRouterAlive"></router-view>
      </el-main>
      <el-footer>

      </el-footer>
    </el-container>

  </div>
</template>

<script>
import Navigation from '../../components/Navigation'
import Footer from '../../components/Footer'
export default {
  name: 'index',
  components:{
    Navigation,
    Footer
  },
  data(){
    return{
      isRouterAlive:true,
    }
  }
}
</script>


<style scoped>
.home-container{
  height: 100%;
}
.el-header, .el-footer {
  padding: 0;
}
.el-main {

  line-height: 160px;
}
.nav-a-li {
  display: inline-block;
}
/* .nav-a-li:active {
  border-bottom: 2px solid #fff;
} */
.nav-a-li:hover .menu-erji {
  display: block;
}
.menu-erji{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/main/index.vue